import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=0a763d5e&"
import script from "./StatusBadge.vue?vue&type=script&lang=ts&"
export * from "./StatusBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports